import { ScheduleFrequencyDays, ScheduleMonthlyFrequencyDays, ScheduleMonthlyFrequencyMonths, ScheduleMonthlyFrequencyOns } from "../model/ChecklistDtos";

export const scheduleFrequencyConverter = {
    bitmaskToDays: function (bitmask?: number): ScheduleFrequencyDays[] {
        if (!bitmask) return []

        const days: ScheduleFrequencyDays[] = [];
        for (const day of Object.values(ScheduleFrequencyDays)) {
            if (typeof day === 'number' && (bitmask & day) === day) {
                days.push(day);
            }
        }
        return days;
    },

    bitmaskToMonthsEnum: function (bitmask?: ScheduleMonthlyFrequencyMonths): ScheduleMonthlyFrequencyMonths[] {
        if (!bitmask) return [];

        return (Object.values(ScheduleMonthlyFrequencyMonths) as number[])
            .filter(v => typeof v === "number" && (bitmask & v) === v)
            .map(v => v as ScheduleMonthlyFrequencyMonths);
    },


    bitmaskToMonthlyDays: function (bitmask?: ScheduleMonthlyFrequencyDays): ScheduleMonthlyFrequencyDays[] {
        if (!bitmask) return [];

        const values = [
            ScheduleMonthlyFrequencyDays.Day1,
            ScheduleMonthlyFrequencyDays.Day2,
            ScheduleMonthlyFrequencyDays.Day3,
            ScheduleMonthlyFrequencyDays.Day4,
            ScheduleMonthlyFrequencyDays.Day5,
            ScheduleMonthlyFrequencyDays.Day6,
            ScheduleMonthlyFrequencyDays.Day7,
            ScheduleMonthlyFrequencyDays.Day8,
            ScheduleMonthlyFrequencyDays.Day9,
            ScheduleMonthlyFrequencyDays.Day10,
            ScheduleMonthlyFrequencyDays.Day11,
            ScheduleMonthlyFrequencyDays.Day12,
            ScheduleMonthlyFrequencyDays.Day13,
            ScheduleMonthlyFrequencyDays.Day14,
            ScheduleMonthlyFrequencyDays.Day15,
            ScheduleMonthlyFrequencyDays.Day16,
            ScheduleMonthlyFrequencyDays.Day17,
            ScheduleMonthlyFrequencyDays.Day18,
            ScheduleMonthlyFrequencyDays.Day19,
            ScheduleMonthlyFrequencyDays.Day20,
            ScheduleMonthlyFrequencyDays.Day21,
            ScheduleMonthlyFrequencyDays.Day22,
            ScheduleMonthlyFrequencyDays.Day23,
            ScheduleMonthlyFrequencyDays.Day24,
            ScheduleMonthlyFrequencyDays.Day25,
            ScheduleMonthlyFrequencyDays.Day26,
            ScheduleMonthlyFrequencyDays.Day27,
            ScheduleMonthlyFrequencyDays.Day28,
            ScheduleMonthlyFrequencyDays.Day29,
            ScheduleMonthlyFrequencyDays.Day30,
            ScheduleMonthlyFrequencyDays.Day31,
            ScheduleMonthlyFrequencyDays.Last
        ];
        return values.filter(v => (bitmask! / v) % 2 >= 1);
    },

    bitmaskToOns: function (bitmask?: ScheduleMonthlyFrequencyOns): ScheduleMonthlyFrequencyOns[] {
        if (!bitmask) return [];

        return (Object.values(ScheduleMonthlyFrequencyOns) as number[])
            .filter(v => typeof v === "number" && (bitmask & v) === v)
            .map(v => v as ScheduleMonthlyFrequencyOns);
    },

}

function bitmaskToEnumArray<T extends Record<string, number>>(
    bitmask: number | undefined,
    enumObj: T
): T[keyof T][] {
    if (!bitmask) return [];

    return (Object.values(enumObj) as number[])
        .filter(v => (bitmask & v) === v)
        .map(v => v as T[keyof T]);
}
